import { datenklasse, messstelle, messwertLog } from './../../../utils/apiTypes';

export enum DataCollectorRequestType {
   all = "all",
   measurements = "measurements",
   events = "events"
}

export interface lambdacontrolState {
   messstellen: messstelle[];
   isMessstellenLoading: boolean;
   selectedMessstellen: messstelle[];
   selectedMessstellenGroups: string[];
   datenklassen: datenklasse[];
   isDatenklassenLoading: boolean;
   selectedDatenklasse: datenklasse;
   startDatum: Date;
   endeDatum: Date;
   messwertLogs: messwertLog[];
   isMesswertLogsLoading: boolean;
}